import { faChartLineDown } from '@fortawesome/pro-solid-svg-icons';
import {
  StrategyConfig,
  StrategyValidationContext,
  CreateStrategyPayload,
  UpdateStrategyPayload,
} from '../types';
import {
  validateDynamicCriteria,
  hasUnfilledCriteriaPlaceholders,
} from '../../Admin/utils/strategyValidation';
import TreatingVolumeConfiguration from '../../Admin/AddEditStrategy/components/StrategyTypes/TreatingVolumeConfiguration';
import { transformCriteriaInputs } from './transformers';

/**
 * Configuration for Treating Volume strategy type
 *
 * Engages/expands providers based on detailed volume and service data.
 * Uses dynamic criteria templates.
 */
export const treatingVolumeConfig: StrategyConfig = {
  type: 'TREATING_VOLUME',
  label: 'Treating Volume',
  description:
    'Engage/Expand providers based on detailed volume and service data',
  icon: faChartLineDown,
  mode: 'engage',
  disabled: false,

  ConfigComponent: TreatingVolumeConfiguration,

  requiredFields: ['label', 'description', 'criteria_template'],

  validateProgress: (context: StrategyValidationContext): boolean => {
    if (context.isEditMode || context.isCopyMode) {
      return !!(
        context.strategyDetails?.criteria_template ||
        context.strategyDetails?.codeSetId ||
        context.strategyDetails?.mode
      );
    }
    const template = context.dynamicCriteria?.criteria_template;
    // Check that template exists and all placeholders have valid data
    return !!template && !hasUnfilledCriteriaPlaceholders(context.dynamicCriteria);
  },

  validateComplete: (context: StrategyValidationContext): boolean => {
    if (context.isEditMode || context.isCopyMode) return true;
    return validateDynamicCriteria(context.dynamicCriteria);
  },

  serializeForCreate: (
    context: StrategyValidationContext
  ): CreateStrategyPayload => {
    return {
      label: context.formData.label,
      description: context.formData.description,
      type: 'TREATING_VOLUME',
      max_opportunities: context.formData.max_opportunities,
      criteria_template: context.dynamicCriteria?.criteria_template || '',
      criteria_inputs: transformCriteriaInputs(
        context.dynamicCriteria?.criteria_inputs
      ),
    };
  },

  serializeForUpdate: (
    context: StrategyValidationContext
  ): UpdateStrategyPayload => {
    return {
      label: context.formData.label,
      description: context.formData.description,
      max_opportunities: context.formData.max_opportunities,
      criteria_template: context.dynamicCriteria?.criteria_template || '',
      criteria_inputs: transformCriteriaInputs(
        context.dynamicCriteria?.criteria_inputs
      ),
    };
  },

  features: {
    hasMaxOpportunities: true,
  },
};
